import React, { useState, useEffect } from "react";
import "./SelectedProperty.scss";

//import components
import MonthYearPicker from "../../Payments/Mobile-and-Tablet/MonthPicker.jsx";
import DonutPercentage from "../../OverView/Pc-and-Large-Screens/DonutPercentage.jsx";
import RemoveHousesModal from "./RemoveHouse.jsx";
import { ToastContainer, toast, Zoom, Bounce } from "react-toastify";

//import icons
import { IoPersonAddOutline } from "react-icons/io5";
import { CgArrowsExchange } from "react-icons/cg";
import { MdApartment } from "react-icons/md";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { CiEdit } from "react-icons/ci";
import HouseListTable from "./HouseList.jsx";
import HouseMoadal from "./EditHouse.jsx";

//imports for user data
import { useSelector,useDispatch } from "react-redux";
import AddBulkHouses from "./AddBulkHouses.jsx";
import { updateHouse,getAllHouses } from "../../../../redux/slices/sliceActions";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";


const SelectedProperty = ({ propertyId,propertyName }) => {
  // data fetched from the store
   const dispatch = useDispatch();
  const { houses } = useSelector((state) => state.landlordslice);
  const [mockHouses, setMockHouses] = useState(houses);

  // modal variable
  const [showModal, setShowModal] = useState(false);
  const [showRemoveHousesModal, setShowRemoveHousesModal] = useState(false);
  const [showAddBulkHousesModal, setShowAddBulkHousesModal] = useState(false);

    //toast functions
  const toastSuccess = (message) => { 
    console.log('Toast called with message:', message);
      toast.success(`${message}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    };
    const toastError = (message) => {
      toast.error(`${message}`, {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    };

  //property details
  const [propertyDetails, setPropertyDetails] = useState({});
  useEffect(() => { 

    //find number of occupied houses
    const occupiedHouses = houses.filter((house) => house.status === "occupied");
    //find number of vacant houses
    const vacantHouses = houses.filter((house) => house.status === "vacant");
    //find number of houses
    const totalHouses = houses.length;
    //find percentage of vacant houses
    const vacantHousesPercentage = (vacantHouses.length / totalHouses) * 100;
    //find percentage of occupied houses
    const occupiedHousesPercentage = (occupiedHouses.length / totalHouses) * 100;

    setPropertyDetails({
      totalHouses,
      vacantHouses: vacantHouses.length,
      occupiedHouses: occupiedHouses.length,
      vacantHousesPercentage,
      occupiedHousesPercentage,
    });
  }, [houses]);
  // house information
  const [houseInformation, setHouseInformation] = useState({});

  // method to add new row
  const handleAddRow = () => {
    const newHouse = {
      _id: Date.now().toString(),
      house_no: "",
      type: "Bed Sitter",
      rent: "",
      meter_no: "",
      initial_meter_reading: "",
      status: "vacant",
      isNewRow: true,
    };
    setMockHouses((prevHouses) => [...prevHouses, newHouse]);
  };

  useEffect(() => {
    setMockHouses(houses);
  }, [houses]);

  const handleConfirmEdit = (updateInformation) => {
    console.log("update information", updateInformation);
 
    dispatch(updateHouse({
      house: updateInformation,
       
      houseId: updateInformation?.house_id,
    })).then((res) => {
    
      if (res?.payload?.status === "success") {
        dispatch(getAllHouses({ id: propertyId }));
        setHouseInformation({});
        toastSuccess("House updated successfully");
      }
    })
  };



  return (
    <div className="mid-section-Tenants-pc-selected-property">
      <div className="title">
       {propertyName}
        <div className="description">Apartment Details and Roles</div>
      </div>
      <div className="cards-container">
        <div className="individual-card">
        <div className="top-card-section">
            <div className="top-left">
              <div className="title">Tenant Information</div>
              <div className="number">{propertyDetails?.occupiedHouses} Tenants</div>
              {/* <div className="date">
                <MonthYearPicker />
              </div> */}
            </div>
            <div className="top-right">
              {/* <div className="apartment">
                <select
                  id="apartment-select"
                  name="apartment"
                  className="apartment-dropdown"
                  onChange={(e) => setSelectedPropertyId(e.target.value)}
                >
                  {properties?.map((property, index) => {
                    return (
                      <option key={index} value={property._id}>
                        {property.name}
                      </option>
                    );
                  })}
                </select>
              </div> */}
            </div>
          </div>
          <div className="bottom-card-section">
            <div className="bottom-left">
              <DonutPercentage
                percentage={((((propertyDetails?.occupiedHouses)) / propertyDetails?.totalHouses) * 100).toFixed(1)|| 0}
                donutSize={"80%"}
                setColors={["#192A3A", "#B39359"]}
              />
            </div>
            <div className="bottom-right">
              <div className="section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Occupied Houses</div>
                    <div className="details">{ propertyDetails?.occupiedHouses}</div>
                  </div>
                </div>
                <div className="shape-container">
                <div className="shape-2" style={{width:`${(((((propertyDetails?.occupiedHouses))/propertyDetails?.totalHouses) * 60) || 0)  + 1}px`,}}></div>
                <div className="text">{((((propertyDetails?.occupiedHouses))/propertyDetails?.totalHouses) * 100).toFixed(1) || 0} %</div>
                </div>
              </div>
              <div className="section second-section">
                <div className="shape-and-text">
                  <div className="shape"></div>
                  <div className="title-and-details">
                    <div className="title">Vacant Houses</div>
                    <div className="details">{(propertyDetails?.totalHouses)-(propertyDetails?.occupiedHouses)}</div>
                  </div>
                </div>
                <div className="shape-container">
                  <div className="shape-2" style={{width:`${(((((propertyDetails?.totalHouses)-(propertyDetails?.occupiedHouses))/propertyDetails?.totalHouses) * 60) || 0)  + 1 }px`,}}></div>
                  <div className="text">{((((propertyDetails?.totalHouses)-(propertyDetails?.occupiedHouses))/propertyDetails?.totalHouses) * 100).toFixed(1) || 0} %</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="individual-card progress-report-card">
          <div className="title">Payments Progress</div>
          <div className="progress">
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Rent</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "70%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#192A3A",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">15,000</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Water</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "30%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#B39359",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">25,000</div>
            </div>
            <div className="progress-container">
              <div className="subtitle-and-shape">
                <div className="individual">Garbage</div>
                <div className="shape">
                  <div style={{ height: "100%", width: "45%" }}>
                    <div
                      className="inner-shape"
                      style={{
                        backgroundColor: "#64A371",
                        height: "100%",
                        width: "100%",
                        borderRadius: vw(5),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="amount">6,000</div>
            </div>
          </div>
          <div className="boundery">
            <div className="amount">0%</div>
            <div className="amount">25%</div>
            <div className="amount">50%</div>
            <div className="amount">75%</div>
            <div className="amount">100%</div>
          </div>
        </div>
        <div className="individual-card actions-container">
          <div className="title">Actions </div>
          <div className="options-container">
            <div className="option" onClick={() => handleAddRow()}>
              <div className="icon-container">
                <IoPersonAddOutline />
              </div>
              <div className="text">Add</div>
            </div>
            <div
              className="option alternate-option"
              onClick={() => setShowModal(true)}
            >
              <div className="icon-container">
                <CiEdit />
              </div>
              <div className="text">Edit</div>
            </div>
            <div
              className="option alternate-option"
              onClick={() => setShowAddBulkHousesModal(true)}
            >
              <div className="icon-container">
                <MdApartment fontSize={25} />
              </div>
              <div className="text">Bulk</div>
            </div>
            <div
              className="option"
              onClick={() => setShowRemoveHousesModal(true)}
            >
              <div className="icon-container">
                <IoPersonRemoveOutline />
              </div>
              <div className="text">Remove</div>
            </div>
          </div>
        </div>
      </div>

      {mockHouses.length > 0 ? (
        <div className="tenant-table-container">
          <div className="description" style={{ margin: `${vh(20)} 0px` }}>
            House List
          </div>
          <HouseListTable
            setShowModal={setShowModal}
            propertyId={propertyId}
            mockHouses={mockHouses}
            setHouseInformation={setHouseInformation}
            toastSuccess={toastSuccess}
            toastError={toastError}
          />
        </div>
      ) : (
        <div className="no-houses-div">No Houses Created yet</div>
      )}

      {showModal && (
        <>
          <HouseMoadal
            setShowModal={setShowModal}
            passedHouseInformation={houseInformation}
            setHouseInformation={setHouseInformation}
            handleConfirmEdit={handleConfirmEdit}
          />
        </>
      )}
      {showRemoveHousesModal && (
        <>
          <RemoveHousesModal
            setShowModal={setShowRemoveHousesModal}
            passedHouseInformation={houseInformation}
            setHouseInformation={setHouseInformation}
            propertyId={propertyId}
            toastSuccess={toastSuccess}
            toastError={toastError}
          />
        </>
      )}
      {showAddBulkHousesModal && (
        <>
          <AddBulkHouses
            setShowAddBulkHousesModal={setShowAddBulkHousesModal}
            propertyId={propertyId}
          />
        </>
      )}

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
    </div>
  );
};

export default SelectedProperty;
